import BigNumber from 'bignumber.js'
import erc20ABI from 'config/abi/erc20.json'
import multicall from 'utils/multicall'
import { getConditionalLiquidityAddress } from 'utils/addressHelpers'
import conditionalLiquidityAbi from 'config/abi/conditionalLiquidity.json'

export const fetchRemovalOrderUserAllowances = async (account: string, lpAddresses: string[]) => {
  const cl = getConditionalLiquidityAddress()

  const calls = lpAddresses.map((lp) => {
    return { address: lp, name: 'allowance', params: [account, cl] }
  })

  const rawLpAllowances = await multicall(erc20ABI, calls)
  const parsedLpAllowances = rawLpAllowances.map((lpBalance) => {
    return new BigNumber(lpBalance).toJSON()
  })
  return parsedLpAllowances
}

export const fetchRemovalOrderUserInfos = async (account: string, lpAddresses: string[]) => {
  const cl = getConditionalLiquidityAddress()

  const calls = lpAddresses.map((lp) => {
    return {
      address: cl,
      name: 'userInfo',
      params: [lp, account],
    }
  })

  const userInfos = await multicall(conditionalLiquidityAbi, calls)
  const parsedUserInfos = userInfos.map((user) => {
    return { 
      stakedBalance: new BigNumber(user[0]._hex).toJSON(),
      hasRuleEnabled: user[1],
      token0Amt: new BigNumber(user[2]._hex).toJSON(),
      token1Amt: new BigNumber(user[3]._hex).toJSON(),
    }
  })
  return parsedUserInfos
}

export const fetchRemovalOrderUserEarnings = async (account: string, lpAddresses: string[]) => {
  const cl = getConditionalLiquidityAddress()

  const calls = lpAddresses.map((lp) => {
    return {
      address: cl,
      name: 'pendingVVS',
      params: [lp, account],
    }
  })

  const rawEarnings = await multicall(conditionalLiquidityAbi, calls)
  // const rawEarnings = calls.map(() => 0); // FIXME debug hard code for warning
  const parsedEarnings = rawEarnings.map((earnings) => {
    return new BigNumber(earnings).toJSON()
  })
  return parsedEarnings
}